import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Modal from 'react-modal';

const customStyles = {
	overlay: {
		position: 'fixed',
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		backgroundColor: 'rgba(0, 0, 0, 0.85)',
	},
	content: {
		top: '30%',
		left: '50%',
		right: 'auto',
		bottom: 'auto',
		marginRight: '-50%',
		transform: 'translate(-50%, -50%)',
		padding: '0',
	},
};

class DeleteDepartmentButton extends Component {
	constructor(props) {
		super(props);

		this.state = {};
		this.openModal = this.openModal.bind(this);
		this.afterOpenModal = this.afterOpenModal.bind(this);
		this.closeModal = this.closeModal.bind(this);
		this.onDelete = this.onDelete.bind(this);
	}

	onChange(e) {
		this.setState({ [e.target.name]: e.target.value });
	}

	onClick(e) {

	}

	openModal() {
		this.setState({ modalIsOpen: true });
	}

	afterOpenModal() {
	}

	closeModal() {
		this.setState({ modalIsOpen: false });
	}

	onDelete() {
		this.props.onClick(this.props.property_id);
		this.closeModal();
	}

	render() {
		const { errors } = this.state;
		return (
			<span>
				<Modal
					isOpen={this.state.modalIsOpen}
					onAfterOpen={this.afterOpenModal}
					onRequestClose={this.closeModal}
					style={customStyles}
					contentLabel="Delete Department"
					newdepartment={this.state.newdepartment}
					ariaHideApp={false}
				>

					<div className="card card-warning">
						<div className="card-header text-white">
                  Delete Department
							{' '}
							<button className="btn btn-sm btn-danger float-end" onClick={this.closeModal}>x</button>
						</div>
						<div className="card-block bg-white text-center">
							<h3>Are You Sure you Want to Delete?</h3>
						</div>
						<div className="card-footer">
							<button className="btn btn-sm btn-danger float-start" onClick={this.closeModal}>Cancel</button>
							<button className="btn btn-sm btn-danger float-end" onClick={this.onDelete}>
								<i className="fas fa-trash-alt" />
								{' '}
Delete Department
							</button>
						</div>
					</div>
				</Modal>
				<button className="btn btn-sm btn-danger float-end space-right-2" onClick={this.openModal}>
Delete Department
					<i className="fas fa-trash-alt" />
				</button>
			</span>
		);
	}
}

function mapStateToProps(state) {
	return {};
}
export default connect(mapStateToProps)(DeleteDepartmentButton);
